import React from 'react';
import { rowCount, type ChangeGroup } from './changeGroups';

/**
 * The working copy bar's "What changed" panel (design review round 27 §4):
 * under Before you publish, a mono header with the count, then each group as
 * rows of `label · before → after`, with swatches for colours and a + or −
 * for what's added or removed. Built by whatChanged (changeGroups.ts).
 */
export function WhatChanged({ groups, since }: { groups: ChangeGroup[]; since: string }) {
  return (
    <div className="ink-wc">
      <div className="ink-site-bar-checks-head">
        What changed since {since} · {rowCount(groups)}
      </div>
      {groups.map((g) => (
        <section key={g.key} className="ink-wc-group">
          <div className="ink-wc-title">{g.title}</div>
          {g.rows.map((r) => (
            <div key={r.key} className="ink-wc-row">
              <span className="ink-wc-label">{r.label}</span>
              <div className="ink-wc-value">
                <div className="ink-wc-line">
                  {r.before != null ? (
                    <span className="ink-wc-before">
                      <Swatches colours={r.swatchesBefore} />
                      {r.before ? <span>{r.before}</span> : null}
                      <span aria-label="to">→</span>
                    </span>
                  ) : null}
                  <span className="ink-wc-after" data-mark={r.mark || undefined}>
                    {r.mark ? <span className="ink-wc-mark">{r.mark}</span> : null}
                    <Swatches colours={r.swatchesAfter} />
                    {r.after ? <span>{r.after}</span> : null}
                  </span>
                </div>
                {r.note ? <span className="ink-wc-note">{r.note}</span> : null}
              </div>
            </div>
          ))}
        </section>
      ))}
    </div>
  );
}

function Swatches({ colours }: { colours?: string[] }) {
  if (!colours?.length) return null;
  return (
    <>
      {colours.map((hex, i) => (
        <span
          key={`${hex}${i}`}
          className="ink-wc-swatch"
          style={{ background: hex }}
          title={hex}
        />
      ))}
    </>
  );
}
